import type { Id } from '@e-socna/data-layer';

import type { FolderPage_OneFolder } from '../../../pages/Folder/hooks/useFindOneFolderQuery.hook';

export enum FolderContextStatus {
  Loading = 'loading',
  NotInitialized = 'notInitialized',
  Ready = 'ready',
  Error = 'error',
}

interface FolderContextLoading {
  readonly status: FolderContextStatus.Loading;
  readonly folderId: Id;
  readonly folder: undefined;
}

interface FolderContextNotInitialized {
  readonly status: FolderContextStatus.NotInitialized;
  readonly folderId: undefined;
  readonly folder: undefined;
}

interface FolderContextReady {
  readonly status: FolderContextStatus.Ready;
  readonly folderId: Id;
  readonly folder: FolderPage_OneFolder;
}

interface FolderContextError {
  readonly status: FolderContextStatus.Error;
  readonly folderId: Id;
  readonly folder: undefined;
}

export type FolderContextData =
  | FolderContextLoading
  | FolderContextNotInitialized
  | FolderContextReady
  | FolderContextError;
